import { Slot } from '@radix-ui/react-slot'
import * as React from 'react'
import { tw } from 'utils/classnames'

interface TypographyProps {
  asChild?: boolean
  variant?: 'heading-2' | 'heading-3' | 'heading-4' | 'body'
  className?: string
  children: React.ReactNode
}

const baseStyles = {
  'heading-2': 'text-24 leading-[2.5rem] font-bold',
  'heading-3': 'text-20 leading-[2.5rem] font-bold',
  'heading-4': 'text-16 leading-[1.25rem] font-bold',
  body: 'text-base leading-[1.5rem]',
}

export const Typography = ({
  asChild,
  variant,
  className,
  ...props
}: TypographyProps & React.HTMLAttributes<HTMLParagraphElement>) => {
  const Component = asChild ? Slot : 'p'

  const typographyClasses = tw(
    'font-poppins text-cf-sf-gray-1100',
    baseStyles[variant || 'body'],
    className,
  )

  return <Component {...props} className={typographyClasses} />
}
